import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Form,
} from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import routes from "../../../../app/routes";

import { useTeamContext } from "../../../../contexts/TeamContext";
import { useEnterpriseMembersContext } from "../../../../contexts/EnterpriseMembersContext";

export default function Filters({ keyword, setKeyword, setTeam, setTemplate }) {
  const {
    dispatch: dispatchTeam,
    actions: actionsTeam,
    state: stateTeam,
  } = useTeamContext();

  const { dispatch, actions, state } = useEnterpriseMembersContext();

  const [templates, setTemplates] = useState(null);

  useEffect(() => {
    actionsTeam.loadTeams(stateTeam.enterpriseId, dispatchTeam);

    axios
      .get(routes.api.enterprises.templates(stateTeam.enterpriseId))
      .then((resp) => {
        setTemplates(resp.data.data);
      });
  }, []);

  return (
    <div className="invite_search">
      <Form className="" horizontal>
        <Row>
          <Col md={6}>
            <FormGroup controlId="member">
              <Col componentClass={ControlLabel} sm={4}>
                Member Name
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                />
              </Col>
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup controlId="programs_assigned">
              <Col componentClass={ControlLabel} sm={4}>
                Programs Assigned
              </Col>
              <Col sm={8}>
                <Select
                  isClearable={true}
                  isSearchable
                  placeholder={templates == null ? "Loading ..." : "Select"}
                  onChange={(option) => {
                    setTemplate(option == null ? "" : option.value);
                  }}
                  options={
                    templates
                      ? templates.map((item) => {
                          return {
                            value: item.id,
                            label: item.attributes.title,
                          };
                        })
                      : []
                  }
                />
              </Col>
            </FormGroup>
          </Col>
          {state.teamId == null && (
            <Col md={6}>
              <FormGroup controlId="team">
                <Col componentClass={ControlLabel} sm={4}>
                  Team
                </Col>
                <Col sm={8}>
                  <Select
                    isClearable={true}
                    isSearchable
                    placeholder={
                      stateTeam.teams == null ? "Loading ..." : "Select"
                    }
                    onChange={(option) => {
                      setTeam(option == null ? "" : option.value);
                    }}
                    options={
                      stateTeam.teams
                        ? stateTeam.teams.map((item) => {
                            return {
                              value: item.id,
                              label: item.attributes.title,
                            };
                          })
                        : []
                    }
                  />
                </Col>
              </FormGroup>
            </Col>
          )}
        </Row>
      </Form>
    </div>
  );
}
